import request from '../utils/request';

// 获取学习内容列表
export const getContents = () => {
  return request.get('/content/list');
};

// 获取播客文件路径
export const getPodcastUrl = () => {
  return request.get('/learn/step2/podcast-url');
};

// 步骤1: 提交跟读录音
export const submitReading = (formData) => {
  return request.post('/learn/step1/submit', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// 步骤2: 提交播客完成记录
export const submitPodcast = (duration, playback_speed) => {
  return request.post('/learn/step2/complete', { duration, playback_speed });
};

// 步骤3: 获取完形填空题目
export const getFillBlanks = () => {
  return request.get('/learn/step3/questions');
};

// 步骤3: 验证单个填空答案
export const checkFillBlank = (fillblank_id, user_answer) => {
  return request.post('/learn/step3/check', { fillblank_id, user_answer });
};

// 步骤3: 提交完形填空答案
export const submitFillBlanks = (answers) => {
  return request.post('/learn/step3/submit', { answers });
};

// 步骤4: 提交评分
export const submitScores = (scores) => {
  return request.post('/learn/step4/submit', { scores });
};

// 步骤5: 获取找茬题目
export const getQuestions = () => {
  return request.get('/learn/step5/questions');
};

// 步骤5: 提交找茬答案
export const submitQuiz = (answers) => {
  return request.post('/learn/step5/submit', { answers });
};

// 步骤6: 提交承诺
export const submitPromise = (weak_item, promise) => {
  return request.post('/learn/step6/submit', { weak_item, promise });
};

// 获取学习进度
export const getProgress = () => {
  return request.get('/learn/progress');
};
